import axios from 'axios';
import { API_BASE_URL } from './apiBase';
import FeatureManagement from '../models/FeatureManagement';

export const getFeatureGate = async (feature: string): Promise<boolean> => {
  const response = await axios.get<boolean>(
    `${API_BASE_URL}/features/${feature}`
  );
  return response.data;
};

export const getFeatureGates = async (): Promise<FeatureManagement> => {
  const featureManagement = new FeatureManagement();
  const keys = FeatureManagement.getKeys();

  const tasks = FeatureManagement.getKeys().map(async (key) => {
    if (key in featureManagement) {
      featureManagement[key] = await getFeatureGate(key);
    }
  });
  await Promise.all(tasks);
  return featureManagement;
};
